module.exports = __webpack_public_path__ + "images/icons/icon-download-blue.svg";